import './AgendaOverview.scss'

import React, {useState} from 'react'

import {PageData} from '../../../types'
import {useTranslation} from '../../../util/i18n'
import {style} from '../../../util/style'
import {CardSwitchType} from '../../layout/cards/CardSwitch'
import {HeroType} from '../../layout/Hero'
import {Overview} from '../../layout/Overview'
import {Theme} from '../../Theme'
import {AgendaDetailType} from '../AgendaDetail'
import {AgendaFilter} from './AgendaFilter'

const styles = style('agendaoverview')

type AgendaOverviewType = {
	agenda: Array<AgendaDetailType>
	project_key?: string
	overview_title?: string
	card_linklabel?: string
}

export const AgendaOverview: React.FC<AgendaOverviewType> = ({
	agenda,
	project_key,
	overview_title,
	card_linklabel
}) => {
	const [agendaItems, setAgendaItems] = useState<Array<AgendaDetailType>>(
		agenda
	)
	const t = useTranslation('agenda').filters.errors
	const hasItems = agendaItems?.length > 0
	const itemsWithImage = agendaItems?.map(
		(item: PageData & {hero: HeroType}): CardSwitchType => {
			const image = item.hero?.image
			const cardItem = {image, ...item}
			return cardItem
		}
	)
	return (
		<div className={styles()}>
			<AgendaFilter
				project_key={project_key}
				onFilterChange={(items) => {
					setAgendaItems(items)
				}}
			/>
			{hasItems && (
				<Overview
					title={overview_title}
					layout="event"
					items={itemsWithImage as Array<CardSwitchType>}
					card_linklabel={card_linklabel}
					maxBeforeLoadMore={6}
					loadItemsPerLoadMore={6}
				/>
			)}
			{!hasItems && (
				<div className={styles('empty')}>
					<Theme.Container>
						<p>{t.no_results}</p>
					</Theme.Container>
				</div>
			)}
		</div>
	)
}
